import React, { useContext } from 'react';
import { ThemeContext } from '../App';

function BalançoFiltrado({ balanco, dataInicioFiltro, dataFimFiltro, faseSelecionada, fases }) {
  const { darkMode } = useContext(ThemeContext);
  if (!balanco) return null;

  // Determina o período do filtro
  let periodo = '';
  if (faseSelecionada && fases[faseSelecionada]) {
    const { ini, fim } = fases[faseSelecionada];
    periodo = `${ini.toLocaleDateString('pt-BR')} até ${fim.toLocaleDateString('pt-BR')}`;
  } else if (dataInicioFiltro && dataFimFiltro) {
    periodo = `${new Date(dataInicioFiltro).toLocaleDateString('pt-BR')} até ${new Date(dataFimFiltro).toLocaleDateString('pt-BR')}`;
  }

  const positivo = parseFloat(balanco.balanco) >= 0;

  return (
    <div
      style={{
        background: positivo
          ? (darkMode ? 'linear-gradient(90deg,#1a2e1a 60%,#1e3a1e)' : 'linear-gradient(90deg,#e8f5e9 60%,#c8e6c9)')
          : (darkMode ? 'linear-gradient(90deg,#2e1a1a 60%,#3a1e1e)' : 'linear-gradient(90deg,#ffebee 60%,#ffcdd2)'),
        border: `2px solid ${positivo ? '#4caf50' : '#f44336'}`,
        borderRadius: 10,
        boxShadow: positivo ? '0 2px 8px #4caf5022' : '0 2px 8px #f4433622',
        padding: '18px 20px',
        marginBottom: 10,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
        fontSize: 15,
        maxWidth: '100%',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{
          fontWeight: 700,
          fontSize: 22,
          color: positivo ? '#2e7d32' : '#c62828',
          letterSpacing: 1,
        }}>
          {positivo ? '▲' : '▼'} {parseFloat(balanco.balanco).toFixed(1)} mm
        </div>
        <span style={{ color: darkMode ? '#aaa' : '#666', fontSize: 13, fontWeight: 500 }}>
          {periodo}
        </span>
      </div>
      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginTop: 2 }}>
        <div style={{ minWidth: 90 }}>
          <span style={{ color: '#388e3c', fontWeight: 600 }}>P:</span> {parseFloat(balanco.totalPrecipitacao).toFixed(1)} mm
        </div>
        <div style={{ minWidth: 90 }}>
          <span style={{ color: '#ef6c00', fontWeight: 600 }}>ETP:</span> {parseFloat(balanco.totalETP).toFixed(1)} mm
        </div>
        <div style={{ minWidth: 60 }}>
          <span style={{ color: '#1976d2', fontWeight: 600 }}>Dias:</span> {balanco.diasAnalisados}
        </div>
      </div>
      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginTop: 2 }}>
        <div style={{ minWidth: 90 }}>
          <span style={{ color: '#1976d2', fontWeight: 600 }}>Temp. média:</span> {balanco.mediaTemp}°C
        </div>
        <div style={{ minWidth: 90 }}>
          <span style={{ color: '#3f51b5', fontWeight: 600 }}>Umid. média:</span> {balanco.mediaUmidade}%
        </div>
      </div>
      <div style={{ marginTop: 6, fontSize: 13, color: positivo ? '#388e3c' : '#c62828', fontWeight: 500 }}>
        {positivo
          ? 'Balanço positivo: Precipitação suficiente para suprir a cultura.'
          : `Déficit hídrico: Evapotranspiração superou a precipitação em ${Math.abs(parseFloat(balanco.balanco)).toFixed(1)} mm.`}
      </div>
    </div>
  );
}

export default BalançoFiltrado;